module.exports = __webpack_public_path__ + "img/pie-chart.e942944e.svg";